// Per fer aquest mòdul de paquests s'ha reutilitzat gran part del codi i estils del mòdul de clients
import { useState, useEffect } from 'react';
import { Package, Edit2, Trash2, X, Search } from 'lucide-react';
import './Paquets.css';
import API_URL from '../config';

function Paquets() {
  const [mostrarFormulari, setMostrarFormulari] = useState(false);
  const [llistaPaquets, setLlistaPaquets] = useState([]);
  const [llistaClients, setLlistaClients] = useState([]); // Llista de clients per al "dropdown"
  const [carregant, setCarregant] = useState(true);
  const [error, setError] = useState('');
  const [errorFormulari, setErrorFormulari] = useState('');
  
  // Camps del formulari
  const [clientId, setClientId] = useState('');
  const [preuTotal, setPreuTotal] = useState('');
  const [sessionsComprades, setSessionsComprades] = useState('');
  const [sessionsRestants, setSessionsRestants] = useState('');
  const [dataCompra, setDataCompra] = useState(new Date().toISOString().split('T')[0]); // Data d'avui per defecte. .toISOString() converteix 2025-12-30T10:56:12 per exemple a 2025-12-30 (es queda nomes amb la data)
  
  const [paquetEditar, setPaquetEditar] = useState(null);
  const [cerca, setCerca] = useState('');
  const [tipusCerca, setTipusCerca] = useState('tot'); // 'tot', 'client', 'sessions', 'preu', per filtrar be
  const [nomesActius, setNomesActius] = useState(false);
  const [sessionsPaquet, setSessionsPaquet] = useState([]);

  // Carregar paquets i clients al iniciar
  useEffect(() => {
    carregarPaquets();
    carregarClients();
  }, []);

  const carregarPaquets = async () => {
    const token = sessionStorage.getItem('token');
    
    if (!token) {
      setError('No estàs autenticat. Si us plau, fes login.');
      setCarregant(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/paquets/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setLlistaPaquets(data);
        setError('');
      } else if (response.status === 401 || response.status === 403) {
        setError(`Autenticació fallida (${response.status}). Torna a fer login.`);
      } else {
        const errorData = await response.text();
        setError(`Error ${response.status}: ${errorData.substring(0, 100)}`); // Mostrar l'inici de l'error
      }
    } catch (err) {
      setError(`Error de connexió: ${err.message}`);
    } finally {
      setCarregant(false);
    }
  };

  const carregarClients = async () => {
    const token = sessionStorage.getItem('token');
    
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/clients/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setLlistaClients(data);
      }
    } catch (err) {
      console.error('Error carregant clients:', err);
    }
  };

  // Filtrar paquets segons el text de cerca
  const paquetsFiltradsCerca = llistaPaquets.filter(paquet => {
  if (!cerca) return true;
  
  const textCerca = cerca.toLowerCase(); // Convertir a minuscules 
  
  switch(tipusCerca) { // Filtrar segons el tipus de cerca
    case 'client':
      return paquet.nom_client?.toLowerCase().includes(textCerca);
    case 'sessions':
      return paquet.sessions_comprades?.toString().includes(textCerca);
    case 'preu':
      return paquet.preu_total?.toString().includes(textCerca);
    default: // 'tot'
      return (
        paquet.nom_client?.toLowerCase().includes(textCerca) ||
        paquet.sessions_comprades?.toString().includes(textCerca) ||
        paquet.preu_total?.toString().includes(textCerca)
      );
  }
  });

  const paquetsFiltrats = nomesActius // si està activat el toggle de "només actius" 
    ? paquetsFiltradsCerca.filter(p => p.sessions_restants > 0)
    : paquetsFiltradsCerca;

  const handleGuardar = async (e) => {
    e.preventDefault();
    setErrorFormulari('');
    
    const token = sessionStorage.getItem('token');
    
    if (!token) {
      setErrorFormulari('No estàs autenticat.');
      return;
    }

    // Validacions
    if (!clientId) {
      setErrorFormulari('Has de seleccionar un client.');
      return;
    }

    if (!preuTotal || parseFloat(preuTotal) <= 0) {
    setErrorFormulari('El preu ha de ser un número vàlid major que 0.');
    return;
    }

    if (!sessionsComprades || parseInt(sessionsComprades) <= 0) {
    setErrorFormulari('Les sessions han de ser un número vàlid major que 0.');
    return;
    }

    const dadesPaquet = { 
        client: parseInt(clientId), // parseInt per assegurar que és un número 
        preu_total: parseFloat(preuTotal), // parseFloat per assegurar que pot ser decimal
        sessions_comprades: parseInt(sessionsComprades),
        sessions_restants: paquetEditar ? parseInt(sessionsRestants) : parseInt(sessionsComprades),
        data_compra: dataCompra
    };

    try {
      if (paquetEditar) {
        // EDITAR paquet existent
        const response = await fetch(`${API_URL}/api/gestio/paquets/${paquetEditar.id}/editar/`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          },
          body: JSON.stringify(dadesPaquet)
        });

        if (response.ok) {
          const paquetActualitzat = await response.json();

          if (sessionsPaquet.length > 0) {
            await fetch(`${API_URL}/api/gestio/paquets/${paquetEditar.id}/guardar-dates/`, {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
              },
              body: JSON.stringify(sessionsPaquet)
            });
          }

          setLlistaPaquets(llistaPaquets.map(paquet => 
            paquet.id === paquetEditar.id ? paquetActualitzat : paquet
          ));
          alert("Paquet i sessions actualitzats correctament!");
          tancarFormulari();
        } else {
          const errorData = await response.json();
          processarErrors(errorData);
        }
      } else {
        // CREAR paquet nou
        const response = await fetch(`${API_URL}/api/gestio/paquets/`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          },
          body: JSON.stringify(dadesPaquet)
        });

        if (response.ok) {
          const paquetCreat = await response.json();
          setLlistaPaquets([...llistaPaquets, paquetCreat]);
          tancarFormulari();
        } else {
          const errorData = await response.json();
          processarErrors(errorData);
        }
      }
    } catch (err) {
      setErrorFormulari(`Error de connexió: ${err.message}`);
    }
  };

  const processarErrors = (errorData) => {
    if (errorData.client) {
      setErrorFormulari(`Client: ${errorData.client[0]}`);
    } else if (errorData.preu_total) {
      setErrorFormulari(`Preu: ${errorData.preu_total[0]}`);
    } else if (errorData.sessions_comprades) {
      setErrorFormulari(`Sessions: ${errorData.sessions_comprades[0]}`);
    } else {
      setErrorFormulari('Error al guardar el paquet. Revisa les dades.');
    }
  };

  const obrirFormulariEditar = async (paquet) => {
    setPaquetEditar(paquet);
    setClientId(paquet.client_id);
    setPreuTotal(paquet.preu_total);
    setSessionsComprades(paquet.sessions_comprades);
    setSessionsRestants(paquet.sessions_restants);
    setDataCompra(paquet.data_compra);
    setErrorFormulari('');
    setMostrarFormulari(true);

    const token = sessionStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/gestio/paquets/${paquet.id}/sessions/`, {
      headers: { 'Authorization': `Token ${token}` }
    });
    if (response.ok) {
      const data = await response.json();
      setSessionsPaquet(data);
    }
  };

  const handleEsborrar = async (id) => {
    if (!window.confirm('Estàs segur que vols esborrar aquest paquet?')) {
      return;
    }

    const token = sessionStorage.getItem('token');
    
    if (!token) {
      setError('No estàs autenticat.');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/paquets/${id}/esborrar/`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        setLlistaPaquets(llistaPaquets.filter(paquet => paquet.id !== id));
      } else {
        setError('Error al esborrar el paquet.');
      }
    } catch (err) {
      setError(`Error de connexió: ${err.message}`);
    }
  };


  const tancarFormulari = () => {
    setMostrarFormulari(false);
    setErrorFormulari('');
    setClientId('');
    setPreuTotal('');
    setSessionsComprades('');
    setSessionsRestants('');
    setDataCompra(new Date().toISOString().split('T')[0]);
    setPaquetEditar(null);
  };

  return (
    <div className="seccio-paquets">
      <div className="capçalera-llista">
        <div className="text-llista">
          <h1>Gestió de paquets</h1>
          <p>Paquets de sessions vinculats als teus clients.</p>
        </div>
        <button className="boto-afegir" onClick={() => setMostrarFormulari(true)}>
          <Package size={18} /> Afegir paquet
        </button>
      </div>

      <div className="taula-contenidor">
        {/* Cercador i toggle de clients actius */}
        <div className="barra-controls">
          {/* Cercador (esquerra) */}
          <div className="contenidor-cerca">
            <div className="input-cerca">
              <Search size={18} className="icona-cerca" />
              
              <select 
                value={tipusCerca} 
                onChange={(e) => setTipusCerca(e.target.value)}
                className="selector-cerca"
              >
                <option value="tot">Tot</option>
                <option value="client">Client</option>
                <option value="sessions">Sessions</option>
                <option value="preu">Preu</option>
              </select>
              
              <input 
                type="text" 
                placeholder={
                  tipusCerca === 'client' ? 'Cerca per client...' :
                  tipusCerca === 'sessions' ? 'Cerca per sessions...' :
                  tipusCerca === 'preu' ? 'Cerca per preu...' :
                  'Cerca...'
                }
                value={cerca}
                onChange={(e) => setCerca(e.target.value)}
                className="camp-cerca"
              />
              
              {cerca && (
                <button className="boto-netejar-cerca" onClick={() => { setCerca(''); setTipusCerca('tot'); }}>
                  <X size={16} />
                </button>
              )}
            </div>
          </div>

          {/* Toggle (dreta) */}
          <div className="contenidor-toggle">
            <span className="etiqueta-toggle">Només actius</span>
            <button
              className={`boto-toggle ${nomesActius ? 'actiu' : ''}`}
              onClick={() => setNomesActius(!nomesActius)}
            >
              <div className="pilota-toggle"></div>
            </button>
          </div>
        </div>

        {error && (
          <div className="missatge-error">
            {error}
          </div>
        )}

        {carregant ? (
          <p>Carregant dades...</p>
        ) : paquetsFiltrats.length === 0 ? (
          <p className="missatge-buit">
            {cerca 
              ? `No s'han trobat paquets amb "${cerca}"`
              : 'No tens cap paquet encara. Afegeix-ne un!'}
          </p>
        ) : (
          <table className="taula-personalitzada">
            <thead>
              <tr>
                <th>Client</th>
                <th>Sessions comprades</th>
                <th>Sessions restants</th>
                <th>Sessions (Assignades / Total)</th>
                <th>Preu total</th>
                <th>Data compra</th>
                <th>Accions</th>
              </tr>
            </thead>
            <tbody>
              {paquetsFiltrats.map(paquet => (
                <tr key={paquet.id}>
                  <td><strong>{paquet.nom_client}</strong></td>
                  <td>{paquet.sessions_comprades}</td>
                  <td>
                    <div className="contenidor-sessions">
                      <span className={`etiqueta-sessions ${paquet.sessions_restants <= 2 ? 'risc' : 'actiu'}`}>
                        {paquet.sessions_restants}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span className="estat-sessions">
                      {paquet.sessions_assignades} / {paquet.sessions_comprades}
                    </span>
                  </td>
                  <td>{paquet.preu_total} €</td>
                  <td>{new Date(paquet.data_compra).toLocaleDateString('ca-ES')}</td>
                  <td className="accions">
                    <button className="icon-btn" onClick={() => obrirFormulariEditar(paquet)}>
                      <Edit2 size={16} />
                    </button>
                    <button className="icon-btn vermell" onClick={() => handleEsborrar(paquet.id)}>
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {mostrarFormulari && (
        <div className="Formulari-overlay">
          <div className="Formulari-contingut">
            <div className="Formulari-header">
              <h3>{paquetEditar ? 'Editar paquet' : 'Nou paquet'}</h3>
              <button className="boto-tancar" onClick={tancarFormulari}>
                <X size={20} />
              </button>
            </div>
            
            <form className="formulari-paquet" onSubmit={handleGuardar}>
              {errorFormulari && (
                <div className="error-formulari">
                  {errorFormulari}
                </div>
              )}
              
              {/* Dropdown de clients per seleccionar un al que vols lligar el paquet*/}
              <div className="camp">
                <label>Client</label>
                <select 
                  value={clientId} 
                  onChange={(e) => setClientId(e.target.value)} 
                  required
                >
                  <option value="">Selecciona un client</option>
                  {llistaClients.map(client => (
                    <option key={client.id} value={client.id}>
                      {client.nom_complet}
                    </option>
                  ))}
                </select>
              </div>

              <div className="camp">
                <label>Sessions comprades</label>
                <input 
                  type="number" 
                  value={sessionsComprades} 
                  onChange={(e) => setSessionsComprades(parseInt(e.target.value))} 
                  min="1"
                  required 
                />
              </div>
              {!paquetEditar && (
                <div className="nota-informativa">
                  Un cop es creï el paquet, podràs assignar la data de cada sessió en el formulari d'edició.
                </div>
              )}

              {paquetEditar && (
                <div className="camp">
                  <label>Sessions restants</label>
                  <input 
                    type="number" 
                    value={sessionsRestants} 
                    readOnly
                    className="input-bloquejat"
                  />
                  <small className="nota-informativa">
                    *Es calcula automàticament segons les sessions realitzades.
                  </small>
                </div>
              )}

              <div className="camp">
                <label>Preu total (€)</label>
                <input 
                  type="number" 
                  step="0.01"
                  value={preuTotal} 
                  onChange={(e) => setPreuTotal(e.target.value)} 
                  min="0"
                  required 
                />
              </div>

              <div className="camp">
                <label>Data de compra</label>
                <input 
                  type="date" 
                  value={dataCompra} 
                  onChange={(e) => setDataCompra(e.target.value)} 
                  required 
                />
              </div>

              {paquetEditar && (
                <div className="camp">
                  <label>Dates de les sessions <small className="nota-check">
                    (Marca el checkbox si la sessió ja s'ha realitzat)
                  </small></label>
                  {sessionsPaquet.map((sessio, index) => (
                    <div key={sessio.id} className="fila-sessio-input">
                      <span>Sessió {index + 1}:</span>
                      <input 
                        type="datetime-local" 
                        value={sessio.data_realitzacio ? sessio.data_realitzacio.substring(0, 16) : ""} 
                        onChange={(e) => {
                          const novesSessions = [...sessionsPaquet];
                          novesSessions[index].data_realitzacio = e.target.value;
                          setSessionsPaquet(novesSessions);
                        }}
                      />
                      <input 
                        type="checkbox" 
                        checked={sessio.es_realitzada}
                        onChange={(e) => {
                            const novesSessions = [...sessionsPaquet];
                            novesSessions[index].es_realitzada = e.target.checked;
                            setSessionsPaquet(novesSessions);
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

              <div className="Formulari-accions">
                <button 
                  type="button" 
                  className="boto-cancelar" 
                  onClick={tancarFormulari}
                >
                  Cancel·lar
                </button>
                <button type="submit" className="boto-guardar">
                  {paquetEditar ? 'Actualitzar' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Paquets;
